var ur = window.location.href;
if (ur.includes('/product')) {
  const productDataEl = document.querySelector('#product-data');
  const installAckType =
    (productDataEl && productDataEl.getAttribute('data-install-ack')) || '';
  const isInGroundTrampoline =
    installAckType === 'in-ground' ||
    Boolean(document.querySelector('#product-data[data-in-ground-trampoline="true"]'));
  const isCommercialPlayset =
    installAckType === 'commercial' ||
    Boolean(document.querySelector('#product-data[data-commercial-playset="true"]'));
  const usesCustomInstallAck = isInGroundTrampoline || isCommercialPlayset;

  if (isInGroundTrampoline) {
    document.documentElement.classList.add('in-ground-trampoline-product');
  }
  if (isCommercialPlayset) {
    document.documentElement.classList.add('commercial-playset-product');
  }

  let optionInjectAttempts = 0;

  const checkExist = setInterval(() => {
    optionInjectAttempts += 1;

    const targets = [
      // Custom install ack UI owns Installation — skip IO Installation inject
      ...(!usesCustomInstallAck
        ? [
            {
              selector: '#infiniteoptions-container fieldset [name*="Installation"]',
              labelText: "I don't need  installation",
              value: "I don't need installation",
              className: 'no-delivery-option',
            },
          ]
        : []),
      {
        selector: '#infiniteoptions-container fieldset [name*="Dirt Removal"]',
        labelText: "I don't need dirt removal",
        value: "I don't need dirt removal",
        className: 'no-dirtremoval-option',
      },
    ];

    if (!targets.length || optionInjectAttempts > 200) {
      clearInterval(checkExist);
      return;
    }

    let allFound = true;

    targets.forEach((opt) => {
      const target = document.querySelector(opt.selector);

      if (target) {
        // Prevent duplicates
        if (target.closest('fieldset').querySelector(`.${opt.className}`)) return;

        if (!usesCustomInstallAck) {
          document
            .querySelectorAll('#infiniteoptions-container fieldset [name*="Installation"]')
            .forEach((el) => {
              const span = el.closest('span');
              const prev = span?.previousElementSibling;
              const label = prev?.querySelector('label');
              if (label) label.innerHTML = 'Installation';
            });
        }

        // Create and insert label
        const label = document.createElement('label');
        label.innerHTML = `
        <input type="checkbox"
               value="${opt.value}"
               class="spb-productoptiontextcolor spb-productoptionbackground ${opt.className} auto-select">
        ${opt.labelText}
      `;
        target.insertAdjacentElement('afterend', label);
      } else {
        allFound = false;
      }
    });

    if (allFound) clearInterval(checkExist);

    const fieldsets = document.querySelectorAll(
      '#infiniteoptions-container > div:not(.accessories_with_image) fieldset'
    );

    fieldsets.forEach((fieldset) => {
      if (fieldset.dataset.exclusiveWired === 'true') return;
      const checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
      if (!checkboxes.length) return;

      fieldset.dataset.exclusiveWired = 'true';

      fieldset.querySelectorAll('.auto-select').forEach((el) => {
        el.checked = true;
      });

      checkboxes.forEach((cb) => {
        cb.addEventListener('change', () => {
          if (cb.checked) {
            checkboxes.forEach((other) => {
              if (other !== cb) other.checked = false;
            });
          }
        });
      });
    });
  }, 300);

  const INSTALL_QUOTE_VALUES = {
    'in-ground': 'Quote provided after Free Yard Evaluation',
    commercial:
      'Installation and delivery will be quoted after purchase since this is a freight item',
  };

  // Sync line-item properties from options (once)
  setInterval(() => {
    const deliveryHidden = document.querySelector('#delivery-property');
    const dirtHidden = document.querySelector('#dirt-removal-property');

    const noDelivery = document.querySelector('input.no-delivery-option');
    const noDirt = document.querySelector('input.no-dirtremoval-option');
    const customInstallChecked = document.documentElement.classList.contains(
      'in-ground-install-checked'
    );
    const customNoInstall = document.querySelector('#in-ground-no-install');
    const ackType =
      (document.querySelector('#product-data') &&
        document.querySelector('#product-data').getAttribute('data-install-ack')) ||
      (isCommercialPlayset ? 'commercial' : isInGroundTrampoline ? 'in-ground' : '');

    const setNamedProperty = (input, name, value) => {
      if (!input) return;
      if (value) {
        input.name = name;
        input.value = value;
      } else {
        input.value = '';
        // Empty properties still serialize and split line items from IO adds
        input.removeAttribute('name');
      }
    };

    // --- Delivery / Installation ---
    if (deliveryHidden) {
      if (customInstallChecked) {
        setNamedProperty(
          deliveryHidden,
          'properties[*Installation]',
          INSTALL_QUOTE_VALUES[ackType] || INSTALL_QUOTE_VALUES['in-ground']
        );
      } else if (customNoInstall && customNoInstall.checked) {
        setNamedProperty(
          deliveryHidden,
          'properties[*Installation]',
          "I don't need installation"
        );
      } else if (noDelivery && noDelivery.checked) {
        setNamedProperty(deliveryHidden, 'properties[*Installation]', noDelivery.value);
      } else {
        setNamedProperty(deliveryHidden, 'properties[*Installation]', '');
      }
    }

    // --- Dirt Removal ---
    if (dirtHidden) {
      if (noDirt && noDirt.checked) {
        setNamedProperty(dirtHidden, 'properties[*Dirt Removal]', noDirt.value);
      } else {
        setNamedProperty(dirtHidden, 'properties[*Dirt Removal]', '');
      }
    }
  }, 300);

  // Theme AJAX + Infinite Options both POST /cart/add for the main variant when
  // Installation (linked product) is selected. Theme owns the main line; strip
  // duplicates from IO payloads. Applies to all product pages with IO.
  (function initIoMainProductDedupe() {
    const DEDUPE_MS = 3000;
    const recentMainAdds = new Map();

    const getMainVariantId = () => {
      const form =
        document.querySelector('form.ajax-product-form [data-add-to-cart]')?.closest('form') ||
        document.querySelector('form.ajax-product-form') ||
        document.querySelector('form[action*="/cart/add"]');
      if (!form) return '';
      const input = form.querySelector('select[name="id"], input[name="id"]');
      return input ? String(input.value || '') : '';
    };

    const isCartAddUrl = (url) => /\/cart\/add(\.js)?(\?|$)/i.test(String(url || ''));

    const markMainAdded = (variantId) => {
      if (!variantId) return;
      recentMainAdds.set(String(variantId), Date.now());
    };

    const wasMainRecentlyAdded = (variantId) => {
      if (!variantId) return false;
      const ts = recentMainAdds.get(String(variantId));
      return Boolean(ts && Date.now() - ts < DEDUPE_MS);
    };

    const isFormUrlEncoded = (body) => {
      if (typeof body !== 'string') return false;
      const trimmed = body.trim();
      return !trimmed.startsWith('{') && !trimmed.startsWith('[');
    };

    // Returns { body, abort }
    const filterCartAddBody = (body) => {
      const mainId = getMainVariantId();
      if (!mainId) return { body, abort: false };

      // Single-item form post (theme, and sometimes IO) — first wins only
      if (isFormUrlEncoded(body)) {
        const params = new URLSearchParams(body);
        if (String(params.get('id')) === mainId) {
          if (wasMainRecentlyAdded(mainId)) return { body, abort: true };
          markMainAdded(mainId);
          return { body, abort: false };
        }
      }

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (String(body.get('id')) === mainId && !body.get('items[0][id]')) {
          if (wasMainRecentlyAdded(mainId)) return { body, abort: true };
          markMainAdded(mainId);
          return { body, abort: false };
        }
      }

      // JSON / items[] — always strip main so linked install / accessories remain
      if (typeof body === 'string') {
        try {
          const json = JSON.parse(body);
          if (Array.isArray(json.items)) {
            const nextItems = json.items.filter((item) => String(item.id) !== mainId);
            if (!nextItems.length) return { body, abort: true };
            if (nextItems.length !== json.items.length) {
              json.items = nextItems;
              return { body: JSON.stringify(json), abort: false };
            }
          }
          if (json.id != null && String(json.id) === mainId && !json.items) {
            if (wasMainRecentlyAdded(mainId)) return { body, abort: true };
            markMainAdded(mainId);
          }
        } catch (e) {
          /* not JSON */
        }
      }

      if (
        typeof body === 'object' &&
        body &&
        !(typeof FormData !== 'undefined' && body instanceof FormData)
      ) {
        if (Array.isArray(body.items)) {
          const nextItems = body.items.filter((item) => String(item.id) !== mainId);
          if (!nextItems.length) return { body, abort: true };
          if (nextItems.length !== body.items.length) {
            return { body: Object.assign({}, body, { items: nextItems }), abort: false };
          }
        }
        if (body.id != null && String(body.id) === mainId && !body.items) {
          if (wasMainRecentlyAdded(mainId)) return { body, abort: true };
          markMainAdded(mainId);
        }
      }

      return { body, abort: false };
    };

    const abortXhr = (xhr) => {
      Object.defineProperty(xhr, 'status', { configurable: true, get: () => 200 });
      Object.defineProperty(xhr, 'readyState', { configurable: true, get: () => 4 });
      Object.defineProperty(xhr, 'responseText', {
        configurable: true,
        get: () => JSON.stringify({ id: 0, status: 'deduped' }),
      });
      Object.defineProperty(xhr, 'response', {
        configurable: true,
        get: () => JSON.stringify({ id: 0, status: 'deduped' }),
      });
      if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
      if (typeof xhr.onload === 'function') xhr.onload();
    };

    if (window.__ioMainCartDedupeInstalled) return;
    window.__ioMainCartDedupeInstalled = true;

    const XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype) {
      const originalOpen = XHR.prototype.open;
      const originalSend = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__ioCartUrl = url;
        this.__ioCartMethod = method;
        return originalOpen.apply(this, arguments);
      };

      XHR.prototype.send = function (body) {
        if (
          this.__ioCartMethod &&
          /post/i.test(this.__ioCartMethod) &&
          isCartAddUrl(this.__ioCartUrl)
        ) {
          const result = filterCartAddBody(body);
          if (result.abort) {
            abortXhr(this);
            return;
          }
          body = result.body;
        }
        return originalSend.call(this, body);
      };
    }

    if (typeof window.fetch === 'function') {
      const originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : input && input.url;
        const method = (init && init.method) || (input && input.method) || 'GET';
        if (/post/i.test(method) && isCartAddUrl(url)) {
          const result = filterCartAddBody(init && init.body);
          if (result.abort) {
            return Promise.resolve(
              new Response(JSON.stringify({ id: 0, status: 'deduped' }), {
                status: 200,
                headers: { 'Content-Type': 'application/json' },
              })
            );
          }
          if (init && result.body !== init.body) {
            init = Object.assign({}, init, { body: result.body });
          }
        }
        return originalFetch(input, init);
      };
    }
  })();

  // Custom Installation UI drives disclaimer + line item property for
  // in-ground trampolines and commercial playsets (quote after purchase).
  // Remove Infinite Options Installation from the DOM (quote flow, not linked SKU).
  (function initCustomInstallDisclaimer() {
    const productData = document.querySelector('#product-data[data-install-ack]');
    if (!productData) return;

    const ackType = productData.getAttribute('data-install-ack');
    const INSTALL_VALUE =
      INSTALL_QUOTE_VALUES[ackType] || INSTALL_QUOTE_VALUES['in-ground'];
    const NO_INSTALL_VALUE = "I don't need installation";

    const optionsRoot = document.getElementById('in-ground-install-options');
    const noInstallInput = document.getElementById('in-ground-no-install');
    const wantInstallInput = document.getElementById('in-ground-want-install');
    const disclaimer = document.getElementById('in-ground-install-disclaimer');
    const acknowledge = document.getElementById('in-ground-install-acknowledge');
    const addToCartBtn = document.querySelector('[data-add-to-cart]');
    const form = addToCartBtn && addToCartBtn.closest('form');

    if (
      !optionsRoot ||
      !noInstallInput ||
      !wantInstallInput ||
      !disclaimer ||
      !acknowledge ||
      !form
    ) {
      return;
    }

    const isInstallFieldset = (fieldset) => {
      if (!fieldset) return false;
      if (fieldset.dataset.ioInstallFieldset === 'true') return true;

      const inputs = Array.from(fieldset.querySelectorAll('input'));
      return inputs.some((input) => {
        const name = (
          input.name ||
          input.dataset.ioOriginalName ||
          ''
        ).toLowerCase();
        if (name.includes('installation')) return true;

        const value = (input.value || '').toLowerCase();
        if (!value.includes('installation')) return false;
        return !value.includes("don't need") && !value.includes('do not need');
      });
    };

    const removeIoInstallation = () => {
      document.querySelectorAll('#infiniteoptions-container fieldset').forEach((fieldset) => {
        if (!isInstallFieldset(fieldset)) return;
        fieldset.dataset.ioInstallFieldset = 'true';
        const wrap = fieldset.closest('div');
        if (wrap && wrap.parentElement && wrap.querySelector('fieldset') === fieldset) {
          const otherFieldsets = wrap.querySelectorAll('fieldset');
          if (otherFieldsets.length <= 1) {
            wrap.remove();
            return;
          }
        }
        fieldset.remove();
      });

      document
        .querySelectorAll(
          '#infiniteoptions-container .no-delivery-option, #infiniteoptions-container input[name*="Installation"]'
        )
        .forEach((el) => {
          const host = el.closest('label') || el.closest('span') || el;
          host.remove();
        });
    };

    removeIoInstallation();
    const ioWatcher = setInterval(removeIoInstallation, 300);
    setTimeout(() => clearInterval(ioWatcher), 30000);

    const isInstallSelected = () => wantInstallInput.checked;

    const isInstallAckMissing = () => isInstallSelected() && !acknowledge.checked;

    const shakeDisclaimer = () => {
      disclaimer.hidden = false;
      form.classList.add('in-ground-install-ack-required');
      disclaimer.classList.remove('in-ground-install-disclaimer--shake');
      void disclaimer.offsetWidth;
      disclaimer.classList.add('in-ground-install-disclaimer--shake');
      if (navigator.vibrate) navigator.vibrate(80);
      acknowledge.focus({ preventScroll: false });
      disclaimer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    const blockAddToCartIfNeeded = (event) => {
      if (!isInstallAckMissing()) return false;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      shakeDisclaimer();
      return true;
    };

    const stampDeliveryProperty = () => {
      const deliveryHidden = document.querySelector('#delivery-property');
      if (!deliveryHidden) return;
      deliveryHidden.name = 'properties[*Installation]';
      deliveryHidden.value = isInstallSelected() ? INSTALL_VALUE : NO_INSTALL_VALUE;
    };

    const syncFromCustomOptions = () => {
      const wantsInstall = wantInstallInput.checked;
      const deliveryHidden = document.querySelector('#delivery-property');

      document.documentElement.classList.toggle('in-ground-install-checked', wantsInstall);
      disclaimer.hidden = !wantsInstall;
      acknowledge.required = wantsInstall;

      if (!wantsInstall) {
        acknowledge.checked = false;
        acknowledge.removeAttribute('required');
        form.classList.remove('in-ground-install-ack-required');
        if (!noInstallInput.checked) noInstallInput.checked = true;
        if (deliveryHidden) {
          deliveryHidden.name = 'properties[*Installation]';
          deliveryHidden.value = NO_INSTALL_VALUE;
        }
        return;
      }

      noInstallInput.checked = false;
      if (deliveryHidden) {
        deliveryHidden.name = 'properties[*Installation]';
        deliveryHidden.value = INSTALL_VALUE;
      }
      if (acknowledge.checked) {
        form.classList.remove('in-ground-install-ack-required');
      }
    };

    noInstallInput.addEventListener('change', () => {
      if (noInstallInput.checked) {
        wantInstallInput.checked = false;
      } else if (!wantInstallInput.checked) {
        noInstallInput.checked = true;
      }
      syncFromCustomOptions();
    });

    wantInstallInput.addEventListener('change', () => {
      if (wantInstallInput.checked) {
        noInstallInput.checked = false;
      } else if (!noInstallInput.checked) {
        noInstallInput.checked = true;
      }
      syncFromCustomOptions();
    });

    acknowledge.addEventListener('change', syncFromCustomOptions);

    if (addToCartBtn) {
      addToCartBtn.addEventListener(
        'click',
        (event) => {
          if (blockAddToCartIfNeeded(event)) return;
          removeIoInstallation();
          stampDeliveryProperty();
        },
        true
      );
    }

    form.addEventListener(
      'submit',
      (event) => {
        if (blockAddToCartIfNeeded(event)) return;
        removeIoInstallation();
        stampDeliveryProperty();
      },
      true
    );

    if (window.jQuery) {
      window.jQuery(form).on('submit.customInstallAck', function (event) {
        if (!isInstallAckMissing()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        shakeDisclaimer();
        return false;
      });
    }

    noInstallInput.checked = true;
    wantInstallInput.checked = false;
    syncFromCustomOptions();
  })();
}
